import React, { useEffect } from "react";
import MiniHero from "./../MiniHero";
import { faqs } from "../../utils/faqs";

function FrequentlyAskedQs({ homeRef, handleScroll }) {
  useEffect(() => {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0;
  }, []);
  return (
    <>
      <MiniHero
        homeRef={homeRef}
        onScroll={handleScroll}
        title="FAQ"
        className="fs-48 text-dark mb-5"
      />
      <div className="container py-5">
        <div className="accordion" id="accordionFAQs">
          {faqs.map((q, index) => (
            <div className="accordion-item">
              <h2 className="accordion-header" id={`heading${index}`}>
                <button
                  className="accordion-button fw-bold bg-gray-100 outline-none boxshadow-none"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${index}`}
                  aria-expanded="false"
                  aria-controls={`collapse${index}`}
                >
                  {index + 1}. {q.title}
                </button>
              </h2>
              <div
                id={`collapse${index}`}
                className={`accordion-collapse collapse ${
                  index === 0 ? "show" : ""
                }`}
                aria-labelledby={`heading${index}`}
                data-bs-parent="#accordionFAQs"
              >
                <div className="accordion-body">
                  <p>{q.content}</p>
                  {q.extra_content && <p>{q.extra_content}</p>}
                  {q.note ? (
                    <div>
                      <p className="fs-14">{q.note}</p>
                      <ol>
                        {q.list.map((list) => (
                          <li className="mb-2">{list}</li>
                        ))}
                      </ol>
                    </div>
                  ) : (
                    <ul>
                      {q.list.map((list) => (
                        <li className="mb-2">{list}</li>
                      ))}
                    </ul>
                  )}
                  {q.bottom_info && <p>{q.bottom_info}</p>}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="my-4">
          <p>
            If you you require any further information feel free to contact us @
            <a className="ms-1" href="mailto: support@tanaad.com">
              support@tanaad.com
            </a>
          </p>
        </div>
      </div>
    </>
  );
}

export default FrequentlyAskedQs;
